import { isNumber, partition } from 'lodash';

import { EMetricTypes, EWithinUnitType } from '@src/emp-3.0/types';

export const parseMetricPayload = (metricsData) => {
  if (metricsData.metrics_type === EMetricTypes.RATIO_METRIC) {
    const { numerator = {}, denominator = {} } = metricsData?.definition ?? {};
    for (const metric of [numerator, denominator]) {
      if (metric['event'] && typeof metric['event'] === 'string') {
        metric['event_raw'] = metric.event;
        delete metric['event'];
      }
    }
  } else {
    const parseList = ['first_event', 'second_event', 'event'];
    parseList.forEach((i) => {
      if (typeof metricsData?.definition?.[i] === 'string') {
        metricsData.definition[`${i}_raw`] = metricsData?.definition?.[i];
        delete metricsData?.definition[i];
      }
    });
  }
  delete metricsData._unit_;
  return metricsData;
};

export const parseFlowPayload = (flowData: any) => {
  // handle raw events
  const events = flowData?.definition?.events;
  if (!events) return flowData;

  const parseList = ['start_event', 'success_event', 'error_event'];

  parseList.forEach((eventKey) => {
    const eventItem = events[eventKey];

    if (Array.isArray(eventItem)) {
      const [rawEvents, mappedEvents] = partition(
        eventItem,
        (item): item is string => typeof item === 'string',
      );
      if (mappedEvents.length) {
        events[eventKey] = mappedEvents;
      } else {
        delete events[eventKey];
      }
      if (rawEvents.length) {
        events[`${eventKey}_raw`] = rawEvents;
      }
    } else if (typeof eventItem === 'string') {
      events[`${eventKey}_raw`] = eventItem;
      delete events[eventKey];
    }
  });

  return flowData;
};

export const valueInSeconds = (params: { value?: number; unit: EWithinUnitType }) => {
  const { value, unit } = params;
  if (!isNumber(value)) {
    return null;
  }
  if (unit === EWithinUnitType.MINUTE) {
    return value * 60;
  }
  if (unit === EWithinUnitType.HOUR) {
    return value * 3600;
  }
  return value;
};

export const checkSuccessConversionWindow = (
  unit: EWithinUnitType,
  value: number,
  maxHours: number = 1,
) => {
  if (
    (unit === EWithinUnitType.HOUR && value > maxHours) ||
    (unit === EWithinUnitType.MINUTE && value > maxHours * 60) ||
    (unit === EWithinUnitType.SECOND && value > maxHours * 60 * 60)
  ) {
    if (maxHours === 1) {
      return Promise.reject('The maximum is 1 hour');
    } else {
      return Promise.reject(`The maximum is ${maxHours} hours`);
    }
  }
  return Promise.resolve();
};
